// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".justify-end[data-v-fe0c9db8]{display:flex;justify-content:end}.validation[data-v-fe0c9db8]{display:flex;flex-direction:row;justify-content:space-around}.loading-creation[data-v-fe0c9db8]{color:blue}.success-creation[data-v-fe0c9db8]{color:green}.error-creation[data-v-fe0c9db8]{color:red}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
